import axios from 'axios';
import { listPayload } from './billingReconciliationMockApi.js';

const BASE_URL = '/api/billing-reconciliation';

const encoded = (value) => encodeURIComponent(String(value));
const cleanParams = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
);
const requestConfig = (params = {}, signal = undefined) => ({
  params: cleanParams(params),
  ...(signal ? { signal } : {}),
});
const makeIdempotencyKey = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `billing-dpe-action-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const listBillingReconciliationDpeActions = async ({ runId, signal, ...params } = {}) => {
  if (!runId && !(params.program && params.serviceMonth)) return listPayload([]);
  const url = runId
    ? `${BASE_URL}/runs/${encoded(runId)}/dpe-actions`
    : `${BASE_URL}/dpe-actions`;
  const { data } = await axios.get(url, requestConfig(params, signal));
  return Array.isArray(data) ? listPayload(data) : data;
};

export const createBillingReconciliationDpeAction = async ({ runId, action } = {}) => {
  if (!runId) throw new Error('runId is required');
  const { data } = await axios.post(`${BASE_URL}/runs/${encoded(runId)}/dpe-actions`, action || {});
  return data;
};

export const updateBillingReconciliationDpeAction = async ({ id, patch = {} } = {}) => {
  if (!id) throw new Error('DPE action id is required');
  const { data } = await axios.patch(`${BASE_URL}/dpe-actions/${encoded(id)}`, patch || {});
  return data;
};

export const deleteBillingReconciliationDpeAction = async ({ id } = {}) => {
  if (!id) throw new Error('DPE action id is required');
  const { data } = await axios.delete(`${BASE_URL}/dpe-actions/${encoded(id)}`);
  return data;
};

export const sendBillingReconciliationDpeActions = async ({
  runId,
  ids = [],
  bac = null,
  dryRun = true,
  userEmail = null,
} = {}) => {
  if (!runId) throw new Error('runId is required');
  const headers = dryRun ? {} : { 'Idempotency-Key': makeIdempotencyKey() };
  const { data } = await axios.post(`${BASE_URL}/runs/${encoded(runId)}/dpe-actions/send`, cleanParams({
    ids,
    bac,
    dryRun,
    userEmail,
  }), { headers });
  return data;
};
